import React from "react";
import {GridTable, ResultsPager} from "../../../../Components/Grid";
import {LoanLibraryHistoryRow} from "./LoanLibraryHistoryRow";
import {isArrayNullOrEmpty} from "../../../../Utilities/Types/arrayUtilities";
import {emptyGuid} from "../../../../Utilities/commonUtilities";

interface LoanLibraryHistoryViewProps {
    handleSetSearchCriteria: (criteria: Record<string, any>) => void;
    loanHistories: Record<string, any>[];
    searchCriteria: Record<string, any>;
    totalRecords: number;
}

export const LoanLibraryHistoryView = ({
    handleSetSearchCriteria,
    loanHistories,
    searchCriteria,
    totalRecords,
}: LoanLibraryHistoryViewProps) => {
    const isHistoriesEmpty = isArrayNullOrEmpty(loanHistories);

    const handleOrderClick = (event: React.MouseEvent<HTMLElement>) => {
        const criteria = {...searchCriteria};
        const columnId = (event.target as HTMLElement).dataset.id;
        criteria.UpdateSorting(columnId);
        handleSetSearchCriteria(criteria);
    };

    const handleFirstClick = () => {
        const criteria = {...searchCriteria};
        criteria.First();
        handleSetSearchCriteria(criteria);
    };

    const handlePreviousClick = () => {
        const criteria = {...searchCriteria};
        criteria.Previous();
        handleSetSearchCriteria(criteria);
    };

    const handleNextClick = () => {
        const criteria = {...searchCriteria};
        criteria.Next();
        handleSetSearchCriteria(criteria);
    };

    const handleLastClick = () => {
        const criteria = {...searchCriteria};
        criteria.Last(totalRecords);
        handleSetSearchCriteria(criteria);
    };

    const pager = (isSecondaryPager: boolean) => (
        <ResultsPager
            handleFirstClick={handleFirstClick}
            handlePreviousClick={handlePreviousClick}
            handleNextClick={handleNextClick}
            handleLastClick={handleLastClick}
            isSecondaryPager={isSecondaryPager}
            totalRecords={totalRecords}
            recordsPerPage={searchCriteria.recordsPerPage}
            currentPage={searchCriteria.page}
            disabled={false}
        />
    );

    return (
        <>
            {pager(false)}
            <GridTable className="searchResults">
                <thead>
                    <tr>
                        <th onClick={handleOrderClick} className="is-clickable" data-id="catalogNumber">
                            Catalog Number
                        </th>
                        <th onClick={handleOrderClick} className="is-clickable" data-id="catalogItemTitle">
                            Title
                        </th>
                        <th onClick={handleOrderClick} className="is-clickable" data-id="serialNumber">
                            Serial Number
                        </th>
                        <th onClick={handleOrderClick} className="is-clickable" data-id="patronName">Patron</th>
                        <th onClick={handleOrderClick} className="is-clickable" data-id="shippingLocation">
                            Shipping Location
                        </th>
                        <th onClick={handleOrderClick} className="is-clickable" data-id="dateCheckedOut">
                            Date Checked Out
                        </th>
                        <th onClick={handleOrderClick} className="is-clickable" data-id="dateDue">
                            Due Date
                        </th>
                        <th onClick={handleOrderClick} className="is-clickable" data-id="dateReturned">
                            Date Returned
                        </th>
                        <th onClick={handleOrderClick} className="is-clickable" data-id="status">Status</th>
                    </tr>
                </thead>
                <tbody>
                    {!isHistoriesEmpty &&
                        loanHistories &&
                        loanHistories.map((loanHistory: Record<string, any>, index: number) => {
                            return (
                                <LoanLibraryHistoryRow
                                    key={loanHistory.loanId && loanHistory.loanId !== emptyGuid ? loanHistory.loanId : `loan-history-${index}`}
                                    loanHistory={loanHistory}
                                />
                            );
                        })}
                    {isHistoriesEmpty && (
                        <tr data-testid="no-results-row">
                            <td colSpan={8} className="text-center">
                                No loan history found.
                            </td>
                        </tr>
                    )}
                </tbody>
            </GridTable>
            {pager(true)}
        </>
    );
};
